@if (data.question) {
  <div class="chat-list-row" id="question{{ data?.sequence_id }}">
    <div class="question">
      {{ data?.question }}
    </div>
  </div>
}
@if (showPaginateSpinner) {
  <div
    class="chat-list-row"
    style="flex-direction: row; justify-content: center"
  >
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
@if (!showPaginateSpinner) {
  @if (data.bot_answer) {
    <div class="chat-list-row">
      <div class="answer">
        <div
          class="answer-content"
          [innerHTML]="changeNewLine(data.bot_answer)"
        ></div>
      </div>
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-bottom: 30px;
      "
    >
      <span> {{ $safeNavigationMigration(data?.created_at) }}</span>
    </div>
  }
}
